import { createBrowserRouter } from 'react-router'
import { Store, StoreDetail } from 'pages'
import { Layout } from 'components/templates'
import { ROUTE_HOME, ROUTE_STORE_DETAIL } from 'constant'

export const router = createBrowserRouter([
  {
    id: 'root',
    path: ROUTE_HOME,
    Component: Layout,
    children: [
      {
        index: true,
        Component: Store,
      },
      { path: ROUTE_STORE_DETAIL, Component: StoreDetail },
    ],
  },
])
